<template>
    <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto">

                <!-- Empty State. -->
                <div v-if="!query" class="text-gray-500 text-sm">
                    Start typing to search for known addresses...
                </div>

                <div v-else class="space-y-6">
                    <div v-if="filteredPackageAddresses.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Package Addresses</div>
                        <div class="space-y-1">
                            <button
                                v-for="packageAddress in filteredPackageAddresses"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="packageAddress.address[0]"
                                @click="selectPackage(packageAddress, close)"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">{{ packageAddress.address[0] }}</div>
                                    <div class="truncate w-full text-xs text-gray-500">
                                        <div v-for="line,index in packageAddress.address" v-if="index>0">{{ line }}</div>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-else class="text-gray-500 text-sm">
                        No matching addresses found.
                    </div>

                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import {routePlanStore} from '@stores'

export default {
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
    },
    data() {
        return {
            query: '',
        }
    },
    computed: {
        $store() {
            return routePlanStore
        },
        filteredPackageAddresses() {
            return this.$store.state.packageAddresses.filter(this.matchAddress).sort((a, b) => {
                return a.similarity <= b.similarity
            }).slice(0, 100);
        },
    },
    methods: {
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery(query) {
            this.query = query
            if (!this.query) return
        },
        matchAddress(packageAddress) {
            const similarity = function (s1, s2) {
                var longer = s1;
                var shorter = s2;
                if (s1.length < s2.length) {
                    longer = s2;
                    shorter = s1;
                }
                var longerLength = longer.length;
                if (longerLength === 0) {
                    return 1.0;
                }
                return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
            }
            const editDistance = function (s1, s2) {
                s1 = s1.toLowerCase();
                s2 = s2.toLowerCase();

                var costs = new Array();
                for (var i = 0; i <= s1.length; i++) {
                    var lastValue = i;
                    for (var j = 0; j <= s2.length; j++) {
                        if (i == 0)
                            costs[j] = j;
                        else {
                            if (j > 0) {
                                var newValue = costs[j - 1];
                                if (s1.charAt(i - 1) !== s2.charAt(j - 1))
                                    newValue = Math.min(Math.min(newValue, lastValue),
                                        costs[j]) + 1;
                                costs[j - 1] = lastValue;
                                lastValue = newValue;
                            }
                        }
                    }
                    if (i > 0)
                        costs[s2.length] = lastValue;
                }
                return costs[s2.length];
            }
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            let ret = query.every((token) => {
                return packageAddress.address.join('|').toLowerCase().includes(token);
            });
            if (ret) {
                packageAddress.similarity = similarity(packageAddress.address[0],this.query)+similarity(packageAddress.address.join(' '),this.query);
            }
            return ret;
        },
        selectPackage(packageAddress, close) {
            this.$emit('selected:packageAddress', packageAddress);
            this.query = packageAddress.address.join(' ');
            close();
        },
    },
}
</script>
